import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

import Input from "../../shared/components/form/input"
import useMyPermission from '../../hooks/useMyPermission'
import useFlashMessage from '../../hooks/useFlashMessage'
import ListRegionRow from './ListRow/ListRegionRow'
import Modal from '../../shared/modal/Modal'
import FormRegion from './form/FormRegion'
import Button from '../../shared/components/Button/Button'

function ListRegion() {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const [regions, setRegions] = useState([])
    const [modalNew, setModalNew] = useState(false)
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    const [myPermission, setMyPermission] = useState({ group: "" })
    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "region_View")
    const myPermissionNew = checkPermission(myPermission, "region_Create")

    const getAll = () => {
        api.get('/region/getall', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                setRegions(response.data.regions)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    useEffect(() => { getAll() }, [token])

    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return regions.filter((item) => (item.regionName || '').toLowerCase().includes(searchLowerCase))
    }, [regions, search])

    async function registerRegion(region) {
        let msgType = 'success'
        const data = await api.post('/region/new', region, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            setModalNew(false)
            getAll()
        }
    }

    if (!load) {
        return <div className="pg-loading">Carregando regiões...</div>
    }

    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Regiões</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionNew && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar região..."
                                    value={search}
                                    handleOnChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'região' : 'regiões'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListRegionRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        myPermission={myPermission}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhuma região encontrada</p>
                        <p className="pg-empty-subtitle">
                            {regions.length === 0
                                ? 'Cadastre a primeira região para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={36}
                h={30}
                content={
                    <FormRegion
                        title="Cadastrar Região"
                        handleSubmit={registerRegion}
                        btCancelAction={() => setModalNew(false)}
                        btnText="Salvar"
                    />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar regiões</p>
        </div>
    )
}

export default ListRegion
